import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import { SearchContext } from "@context/SearchContext";
import Button from "@components/Ui/Button";
import PrimarySessions from "@components/V3/MovieDetails/PrimarySessions";
import SecondarySessions from "@components/V3/MovieDetails/SecondarySessions";

const MovieSessionSelector = ({ venueName, selection = {}, selectedSessions = {} }) => {
    const { userCoords, openDrawer } = useContext(AuthContext);

    const { movie } = useContext(SearchContext);

    const primarySessions = selectedSessions.primary;
    const secondarySessions = selectedSessions.secondary;
    
    return (
        <>
            {(
                (primarySessions && Object.keys(primarySessions).length > 0) || 
                (secondarySessions && Object.keys(secondarySessions).length > 0)
            ) ? (
                <>
                    <PrimarySessions
                        groupedSessions={primarySessions}
                        selection={selection}
                    />
                    {selection.date && venueName && (
                        <SecondarySessions
                            venueName={venueName}
                            movieTitle={movie?.title}
                            secondarySessions={secondarySessions}
                            selection={selection}
                        />
                    )}
                </>
            ) :  ((userCoords?.latitude || userCoords?.longitude || venueName) ? (
                <div className="sessions-available__message">
                    <p className="sessions-available__message-title">
                        Sorry, we couldn&apos;t find any results for your chosen cinema
                    </p>
                    <p className="sessions-available__message-text">
                        Please select from one of the nearby sessions below, or select a different date
                    </p>
                </div>
            ) : (
                <div className="sessions-available__message">
                    <p className="sessions-available__message-title">
                        Looks like you haven&apos;t chosen a cinema
                    </p>
                    <p className="sessions-available__message-text">
                        Please&nbsp;
                        <Button additionalClasses="venue-finder__button" onClick={() => openDrawer("venuesDrawer")}>
                            select a cinema
                        </Button >
                        , or enable location services in your browser to see sessions.
                    </p>
                </div>
            ))}
        </>
    );
};

export default MovieSessionSelector;
